import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navigation = ({ mobileMenuOpen, toggleMobileMenu }) => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const currentScroll = window.scrollY;
      const scrollPercentage = (currentScroll / totalScroll) * 100;
      setScrollProgress(scrollPercentage);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="text-2xl flex items-center font-['Pacifico'] text-primary pl-4">
            <img className="w-36" src="/img/logo.png" alt="OnGroom Logo"/>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="#features" className="text-gray-600 hover:text-primary font-medium">Features</a>
            <a href="#rewards" className="text-gray-600 hover:text-primary font-medium">Rewards</a>
            <a href="#how-it-works" className="text-gray-600 hover:text-primary font-medium">How It Works</a>
            <a href="#faq" className="text-gray-600 hover:text-primary font-medium">FAQ</a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a href="#waitlist" className="bg-primary hover:bg-primary-dark text-white px-6 py-2 rounded-button font-medium transition duration-300">Join Waitlist</a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-500 focus:outline-none" 
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <i className="ri-close-line text-2xl"></i>
            ) : (
              <i className="ri-menu-line text-2xl"></i>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4">
            <nav className="flex flex-col space-y-4">
              <a href="#features" className="text-gray-600 hover:text-primary font-medium" onClick={toggleMobileMenu}>Features</a>
              <a href="#rewards" className="text-gray-600 hover:text-primary font-medium" onClick={toggleMobileMenu}>Rewards</a>
              <a href="#how-it-works" className="text-gray-600 hover:text-primary font-medium" onClick={toggleMobileMenu}>How It Works</a>
              <a href="#faq" className="text-gray-600 hover:text-primary font-medium" onClick={toggleMobileMenu}>FAQ</a>
              <a href="#waitlist" className="bg-primary hover:bg-primary-dark text-white px-6 py-2 rounded-button font-medium transition duration-300 text-center" onClick={toggleMobileMenu}>Join Waitlist</a>
            </nav>
          </div>
        )}
      </div>
      {/* Scroll Progress Bar */}
      <div className="h-1 bg-gray-200 w-full">
        <div 
          className="h-full bg-primary transition-all duration-300 ease-out" 
          style={{ width: `${scrollProgress}%` }}
        ></div>
      </div>
    </header>
  );
};

export default Navigation;